import { useMemo } from "react";
import { theme } from "@chakra-ui/react";
import { FeatureCollection, Point } from "geojson";
import { Layer, Source } from "react-map-gl";

import { INFERENCES_CLASSES, getLikelySpecies } from "../utils";
import { Inference, InferenceCollection, InferenceProperties } from "../types/inferences";

type Props = {
  data?: InferenceCollection
  id: string
}

type InferenceLayerProperties = InferenceProperties & {
  "species": string,
  "confidence": string,
}

function InferencesLayer({ data, id }: Props) {
  const inferences = useMemo((): FeatureCollection<Point, InferenceLayerProperties> | undefined => {
    if (data && data.features) {
      return {
        type: "FeatureCollection",
        features: data.features.map(
          (f: Inference) => {
            const { species, confidence } = getLikelySpecies(f);
            const properties = {...f.properties, species, confidence};
            return {...f, properties};
          }
        ),
      };
    }
    return undefined;
  }, [data]);

  return (
    <Source
      id={id}
      type="geojson"
      data={inferences}
    >
      <Layer
        id={id}
        type="circle"
        paint={{
          "circle-color": [
            "match",
            ["get", "species"],
            ...Object.entries(INFERENCES_CLASSES).flatMap(([k, v]) => [k, v.color]),
            theme.colors.gray["500"], // fallback-color
          ],
          "circle-radius": {
            "base": 1.75,
            "stops": [
              [8, 2],
              [22, 180]
            ]
          },
        }}
      />
    </Source>
  );
}

export default InferencesLayer;
